export default __webpack_public_path__ + "static/media/Error404.043d4b34.svg";